export type Price = {
  /** Already formatted in the subscription currency, e.g. "A$42" */
  amount: string
  billingPeriod: number
  billingPeriodUnit: 'month' | 'year'
}

/** Formats a price with its billing period, e.g. "A$38 per month" or "A$700 every 2 years". */
export const formatPrice = ({
  amount,
  billingPeriod,
  billingPeriodUnit,
}: Price): string =>
  billingPeriod === 1
    ? `${amount} per ${billingPeriodUnit}`
    : `${amount} every ${billingPeriod} ${billingPeriodUnit}s`
